import { render } from "./ElAside.vue?vue&type=template&id=3f0ffc7a"
import script from "./ElAside.vue?vue&type=script&lang=js"
export * from "./ElAside.vue?vue&type=script&lang=js"

import "./ElAside.vue?vue&type=style&index=0&id=3f0ffc7a&lang=scss"

import exportComponent from "F:\\work\\angren\\cabinet\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__